import { Injectable, signal, inject, effect } from '@angular/core';
import { NavigationService } from '../services/navigation.service';

@Injectable({
    providedIn: 'root'
})
export class GlobalStateService {
    // SERVICES
    private navigationService = inject(NavigationService);

    private externalLoginFailedSignal = signal<boolean>(false);
    readonly externalLoginFailed = this.externalLoginFailedSignal.asReadonly();

    private isSidemenuVisibleSignal = signal<boolean>(true);
    readonly isSidemenuVisible = this.isSidemenuVisibleSignal.asReadonly();

    private isSidemenuHiddenSignal = signal<boolean>(false);
    readonly isSidemenuHidden = this.isSidemenuHiddenSignal.asReadonly();

    private isHeaderHiddenSignal = signal<boolean>(false);
    readonly isHeaderHidden = this.isHeaderHiddenSignal.asReadonly();

    private openedMenuMobileSizeSignal = signal<boolean>(false);
    readonly openedMenuMobileSize = this.openedMenuMobileSizeSignal.asReadonly();

    private inmobileSignal = signal<boolean>(false);
    readonly inmobile = this.inmobileSignal.asReadonly();

    constructor() {
        effect(() => {
            this.isSidemenuHiddenSignal.set(this.navigationService.hideSidemenuForRoute());
        });

        effect(() => {
            this.isHeaderHiddenSignal.set(this.navigationService.hideHeaderForRoute());
        });
    }

    // PUBLIC METHODS
    setExternalLoginFailed(value: boolean) {
        this.externalLoginFailedSignal.set(value);
    }

    setOpenedMenuMobileSize(value: boolean) {
        this.openedMenuMobileSizeSignal.set(value);
    }

    setSidemenuVisible(value: boolean) {
        this.isSidemenuVisibleSignal.set(value);
    }

    setHeaderHidden(value: boolean) {
        this.isHeaderHiddenSignal.set(value);
    }

    setInmobile(value: boolean) {
        this.inmobileSignal.set(value);
    }

    toggleSidemenuVisibility() {
        this.isSidemenuVisibleSignal.update((prev) => !prev);
    }
}
